import { makeActionCreator } from '../../config/store/utils'
import { searchProvider } from '../../services/search'
export const CLOSE_SEARCH_BUYER_PANEL_SUCCESS = 'CLOSE_SEARCH_BUYER_PANEL_SUCCESS'
export const onCloseSearchBuyerPanelSuccess = makeActionCreator(CLOSE_SEARCH_BUYER_PANEL_SUCCESS)

export const OPEN_SEARCH_BUYER_PANEL_SUCCESS = 'OPEN_SEARCH_BUYER_PANEL_SUCCESS'
export const onOpenSearchBuyerPanelSuccess = makeActionCreator(OPEN_SEARCH_BUYER_PANEL_SUCCESS)

export const GET_ENTITY_BUYER_PANEL_OPTIONS = 'GET_ENTITY_BUYER_PANEL_OPTIONS'
export const GET_ENTITY_BUYER_PANEL_OPTIONS_ERROR = 'GET_ENTITY_BUYER_PANEL_OPTIONS_ERROR'
export const GET_ENTITY_BUYER_PANEL_OPTIONS_SUCCESS = 'GET_ENTITY_BUYER_PANEL_OPTIONS_SUCCESS'
export const onGetEntityBuyerPanelOptions = makeActionCreator(GET_ENTITY_BUYER_PANEL_OPTIONS)
export const onGetEntityBuyerPanelOptionsError = makeActionCreator(GET_ENTITY_BUYER_PANEL_OPTIONS_ERROR, 'payload')
export const onGetEntityBuyerPanelOptionsSuccess = makeActionCreator(GET_ENTITY_BUYER_PANEL_OPTIONS_SUCCESS, 'payload')
export const onGetEntityBuyerPanelOptionsThunk = payload => async dispatch => {
  dispatch(onGetEntityBuyerPanelOptions())

  try {
    const response = await searchProvider({ term: payload.term })
    const options = response.data.map(result => ({
      cat: result.sector,
      name: result.name,
      value: result.entcode
    }))

    return dispatch(onGetEntityBuyerPanelOptionsSuccess({ options }))
  } catch (error) {
    return dispatch(onGetEntityBuyerPanelOptionsError({ error }))
  }
}
